import { Component } from 'react';
/**
 * Abstract React {@code Component} which can display speech-to-text results
 * from Jigasi as subtitles.
 */
export class AbstractCaptions extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {React$Element}
     */
    render() {
        const { _requestingSubtitles, _transcripts } = this.props;
        if (!_requestingSubtitles || !_transcripts || !_transcripts.size) {
            return null;
        }
        const paragraphs = [];
        for (const [id, text] of _transcripts) {
            paragraphs.push(this._renderParagraph(id, text));
        }
        return this._renderSubtitlesContainer(paragraphs);
    }
}
/**
 * Formats the transcript messages into text by prefixing participant's name to
 * avoid duplicating the effort on platform specific component.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {Map<string, string>} - Formatted transcript subtitles mapped by
 * transcript message IDs.
 */
function _constructTranscripts(state) {
    const { _transcriptMessages } = state['features/subtitles'];
    const transcripts = new Map();
    for (const [id, transcriptMessage] of _transcriptMessages) {
        if (transcriptMessage) {
            let text = `${transcriptMessage.participantName}: `;
            if (transcriptMessage.final) {
                text += transcriptMessage.final;
            }
            else {
                const stable = transcriptMessage.stable || '';
                const unstable = transcriptMessage.unstable || '';
                text += stable + unstable;
            }
            transcripts.set(id, text);
        }
    }
    return transcripts;
}
/**
 * Maps the transcriptionSubtitles in the redux state to the associated props of
 * {@code AbstractCaptions}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {{
 *     _requestingSubtitles: boolean,
 *     _transcripts: Map<string, string>
 * }}
 */
export function _abstractMapStateToProps(state) {
    const { _requestingSubtitles } = state['features/subtitles'];
    const transcripts = _constructTranscripts(state);
    return {
        _requestingSubtitles,
        // avoid rerenders by setting to props new empty Map instances.
        _transcripts: transcripts.size === 0 ? undefined : transcripts
    };
}
